/* modified by slaven 2016.9.23 because of timezone */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { UserService } from '@/domains/user/services/user-service.interface';
dayjs.extend(utc);
export default function formatDate(date, dateOnly = false) {
    const i18n = injectService(i18nSymbol);
    const dateFormat = i18n.t('global.format.date');
    const timeFormat = i18n.t('global.format.time');
    const fmt = dateOnly ? dateFormat : `${dateFormat} ${timeFormat}`;
    let str = dayjs(date).format(fmt);
    const userService = injectService(UserService);
    const timezoneInDB = userService.userSetting?.time_zone;
    if (timezoneInDB && timezoneInDB.utc_offset) {
        let timezoneStr;
        if (typeof date === 'number' && date > 0) {
            const timestampStr = dayjs.utc(date).format();
            timezoneStr = timestampStr; // + timezoneInDB.utc_offset;
        }
        else {
            timezoneStr = date; // + timezoneInDB.utc_offset;
        }
        const now = dayjs().utcOffset(timezoneInDB.utc_offset);
        const timezoneTime = dayjs(timezoneStr)
            .utcOffset(timezoneInDB.utc_offset)
            .format(fmt);
        str = timezoneTime.replace(now.format(dateFormat), i18n.t('global.date.today'));
        str = str.replace(now.subtract(1, 'days').format(dateFormat), i18n.t('global.date.yesterday'));
    }
    else {
        str = str.replace(dayjs().format(dateFormat), i18n.t('global.date.today'));
        str = str.replace(dayjs()
            .subtract(1, 'days')
            .format(dateFormat), i18n.t('global.date.yesterday'));
    }
    return str;
}
